import React from 'react'
import styled from 'styled-components'
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js'
import { Line } from 'react-chartjs-2'
import { useDarkMode } from '../../../common/hooks/DarkModeContext'
import utils from '../../../common/utils'
import ColorConfig from '../../../config/ColorConfig'

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend)

const DateLineChart = ({ startDate, data }) => {
	// @ts-ignore
	const chartRef = React.useRef<Line | null>(null)

	const focusOnGreatestIndex = React.useCallback(() => {
		if (data == null || data.length === 0) return

		const greatestIndex = data.lastIndexOf(Math.max(...data))
		const chart = chartRef.current
		if (greatestIndex >= 0 && data[greatestIndex] !== 0) {
			chart?.tooltip?.setActiveElements([{ datasetIndex: 0, index: greatestIndex }], { x: 0, y: 0 })
			chart?.update()
		}
	}, [data])

	React.useEffect(() => {
		focusOnGreatestIndex()
	}, [data])

	const { isDark } = useDarkMode()

	return (
		<ChartContainer onMouseLeave={() => setTimeout(focusOnGreatestIndex, 50)}>
			<Line
				ref={chartRef}
				data={{
					labels: [
						...Array.from({ length: data.length }, (_, i) => {
							let day = new Date(startDate).setDate(new Date(startDate).getDate() + i)
							return new Date(day).getDate() + '일'
						}),
					],
					datasets: [
						{
							backgroundColor: '#1cb15a',
							borderColor: '#1cb15a',
							pointBackgroundColor: ColorConfig.Primary,
							pointBorderColor: ColorConfig.Primary,
							data: data,
						},
					],
				}}
				options={{
					onHover: (_event, activeElements) => {
						if (activeElements.length === 0) focusOnGreatestIndex()
					},
					plugins: {
						legend: { display: false },
						tooltip: {
							callbacks: {
								label: (context) => utils.formatMinutes(context.raw as number),
							},
						},
					},
					scales: {
						x: {
							ticks: { color: isDark ? '#AAA' : '#666' },
							grid: { color: isDark ? '#FFFFFF1A' : '#0000001A' },
						},
						y: {
							min: 0,
							suggestedMax: 60,
							ticks: {
								color: isDark ? '#AAA' : '#666',
								callback: (value) => utils.formatMinutesCompact(value as number),
							},
							grid: { color: isDark ? '#FFFFFF1A' : '#0000001A' },
						},
					},
					interaction: { mode: 'nearest', axis: 'x', intersect: false },
					maintainAspectRatio: false,
				}}
			/>
		</ChartContainer>
	)
}

const ChartContainer = styled.div`
	width: 100%;
	height: 350px;
	overflow: hidden;
`

export default DateLineChart
